module.exports = __webpack_public_path__ + "img/AT0000002305967.a4d8923a.png";